import { render } from "./AppTab.vue?vue&type=template&id=7d72f4d0&scoped=true&ts=true"
import script from "./AppTab.vue?vue&type=script&lang=ts"
export * from "./AppTab.vue?vue&type=script&lang=ts"

import "./AppTab.vue?vue&type=style&index=0&id=7d72f4d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d72f4d0"]])

export default __exports__